import React from 'react';

const Checkbox = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#CEB5E7" />
    <path d="M7 11.3332L11 14.9998L18 7.6665" stroke="black" strokeWidth="2" strokeMiterlimit="10" />
  </svg>
);

export default Checkbox;
